const STEPS = [
  {
    n: "01",
    title: "Connect your store",
    body: "One-click install for Shopify, WooCommerce, BigCommerce, Wix, Squarespace, and Magento — or use our API for everything else. We sync your customers securely through each platform's official customer API. No CSVs, no engineering required.",
    meta: "Setup time · under 2 minutes",
  },
  {
    n: "02",
    title: "AI scans every customer",
    body: "Our model cross-references email, name, and order history against Instagram, TikTok, YouTube and X — attaching handles, follower counts, and engagement rates automatically.",
    meta: "Match accuracy · 94% verified handles",
  },
  {
    n: "03",
    title: "Reach out while they're hot",
    body: "Filter by follower tier, niche, and spend. Export to Klaviyo, Mailchimp, or Gorgias — or ship a pre-written outreach DM in one click. They already love your product.",
    meta: "Avg. reply rate · 6.4× cold outreach",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works"
      className="section-cream relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-[11px] tracking-[0.3em] uppercase text-black/50 font-semibold">
            How it works
          </p>
          <h2
            data-testid="how-it-works-title"
            className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl mt-4 text-black"
          >
            From order list <br />
            to <span className="bg-[#09090B] text-[#D4FF00] px-2">creator list</span> <br />
            in three moves.
          </h2>
        </div>

        <div className="mt-16 space-y-6">
          {STEPS.map((s, idx) => (
            <div
              key={s.n}
              data-testid={`step-${s.n}`}
              className="group grid grid-cols-12 gap-6 md:gap-12 py-10 border-t border-black/15 items-start"
              style={{ animationDelay: `${idx * 80}ms` }}
            >
              <div className="col-span-12 md:col-span-3">
                <div className="font-display text-[6rem] md:text-[8rem] leading-none text-black/10 group-hover:text-[#09090B] transition-colors duration-300">
                  {s.n}
                </div>
              </div>
              <div className="col-span-12 md:col-span-6">
                <h3 className="font-display uppercase text-3xl md:text-4xl text-black">
                  {s.title}
                </h3>
                <p className="mt-4 text-base md:text-lg text-black/70 leading-relaxed max-w-xl">
                  {s.body}
                </p>
              </div>
              <div className="col-span-12 md:col-span-3 md:border-l md:border-black/15 md:pl-6">
                <p className="text-xs tracking-[0.18em] uppercase font-mono-id text-black/60">
                  {s.meta}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
